import styled from 'styled-components';

import { Button } from '@xingternal/button';
import { Card } from '@xingternal/card';
import { mediaConfined } from '@xingternal/layout-tokens';
import { spaceS, spaceXL } from '@xingternal/tokens';

export const StyledButton = styled(Button)`
  line-height: 14px;
`;

export const StyledHRContainer = styled(Card)`
  width: 100%;
  height: 100%;
  cursor: pointer;
  padding: ${spaceXL};

  /* ProfileInfo already has 16px top/bottom padding in this case */
  @media ${mediaConfined} {
    padding: ${spaceS} ${spaceXL};
  }
`;
